import React from "react";
import { Table } from "antd";
import { useTaskHubState } from "shared/hooks/useTaskHubState";
import { MachineItem, UserItem } from "shared/api";
import { TaskHubItem } from "shared/api/task-hub";
import { ColumnsType } from "antd/es/table";
import { AddTaskModal } from "./AddTaskModal";
import { EditTaskModal } from "./EditTask";
import TaskScheduleTable from "./TaskScheduleTable";

interface TaskHubMainProps {
  data: { results: TaskHubItem[]; count: number } | undefined;
  isLoading: boolean;
  currentPage: number;
  pageSize: number;
  setCurrentPage: (page: number) => void;
  setPageSize: (size: number) => void;
  columns: ColumnsType<TaskHubItem>;
  suppliersCompaniesFormatted: { label: string; value: number }[] | undefined;
  machinesData: MachineItem[] | undefined;
  allUsers: UserItem[];
  transformedUsers: { label: string; value: number | null | undefined }[];
  modalState: ReturnType<typeof useTaskHubState>;
  refetch: () => void;
  taskScheduleRef: React.RefObject<{ refetchExecutions: () => void }>;
}

export const TaskHubMain: React.FC<TaskHubMainProps> = ({
  data,
  isLoading,
  currentPage,
  pageSize,
  setCurrentPage,
  setPageSize,
  columns,
  suppliersCompaniesFormatted,
  machinesData,
  allUsers,
  transformedUsers,
  refetch,
  taskScheduleRef,
  modalState,
}) => {
  return (
    <>
      {/* Main TaskHub table */}
      <Table<TaskHubItem>
        dataSource={data?.results || []}
        columns={columns}
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50"],
          current: currentPage,
          pageSize,
          total: data?.count || 0,
          showSizeChanger: true,
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          },
        }}
        loading={isLoading}
        scroll={{ x: true }}
        rowKey="id"
      />

      {/* Add task modal */}
      <AddTaskModal
        suppliersCompaniesFormatted={suppliersCompaniesFormatted}
        machinesData={machinesData}
        transformedUsers={transformedUsers}
        open={modalState.isAddModalOpen}
        onClose={() => modalState.setIsAddModalOpen(false)}
        refetchExecutions={() => taskScheduleRef.current?.refetchExecutions?.()}
      />

      {/* Edit task modal */}
      <EditTaskModal
        suppliersCompaniesFormatted={suppliersCompaniesFormatted}
        transformedUsers={transformedUsers}
        open={modalState.isEditModalOpen}
        taskId={modalState.editingTask}
        onClose={() => modalState.setIsEditModalOpen(false)}
        refetch={refetch}
        refetchExecutions={() => taskScheduleRef.current?.refetchExecutions?.()}
      />

      {/* Schedule table */}
      <TaskScheduleTable
        ref={taskScheduleRef}
        machinesData={machinesData}
        allUsers={allUsers}
        transformedUsers={transformedUsers}
      />
    </>
  );
};
